const NavLinks = {
  MATCH_CHECK_PAYMENTS: '/matchcheckpayments',
  MATCH_CHECK_PAYMENTS_DETAIL: '/matchcheckpayments/detail',
};

export default NavLinks;